import {SummaryBar} from "@/components/summaryBar/SummaryBar.tsx";
import {SummaryBlock} from "@/components/summaryBar/SummaryBar.types.ts";
import {formatResponseTime, MinMaxAvg} from "@/pages/checks/analysis/overview/utils.ts";

interface ResponseTimeStatsCardsProps {
  stats: MinMaxAvg;
}

export const ResponseTimeStatsCards = ({stats}: ResponseTimeStatsCardsProps) => {
  const summaryBlocks: SummaryBlock<MinMaxAvg>[] = [
    {
      title: "High",
      renderStat: (stats) => <>{stats.max ? formatResponseTime(stats.max) : "N/A"}</>,
    },
    {
      title: "Low",
      renderStat: (stats) => <>{stats.min ? formatResponseTime(stats.min) : "N/A"}</>,
    },
    {
      title: "Average",
      renderStat: (stats) => <>{stats.avg ? formatResponseTime(stats.avg) : "N/A"}</>,
    },
  ];

  return <SummaryBar stats={stats} summaryBlocks={summaryBlocks} />;
};
